module.exports = __webpack_public_path__ + "img/a perfect day for errands_.045028e1.png";